import React from 'react';

type P = {
  title: string;
  rightContent?: React.ReactNode;
};

const Header = ({ title, rightContent }: P) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '14px 20px',
        backgroundColor: 'var(--dk-bg, white)',
      }}
    >
      <div
        style={{
          fontSize: '28px',
          fontWeight: '600',
        }}
      >
        {title}
      </div>
      {rightContent}
    </div>
  );
};

export default Header;
